import { PaginationProps as MuiPaginationProps, Select, MenuItem, FormControl, Box, Typography } from '@mui/material';
import { StyledPagination, PaginationContainer, PageSizeSelect } from './styles';

interface CustomPaginationProps extends Omit<MuiPaginationProps, 'onChange'> {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  pageSize?: number;
  onPageSizeChange?: (pageSize: number) => void;
  showPageSizeSelector?: boolean;
}

const PAGE_SIZE_OPTIONS = [15, 30, 50];

export const CustomPagination = ({ 
  currentPage, 
  totalPages, 
  onPageChange,
  pageSize = 15,
  onPageSizeChange,
  showPageSizeSelector = false,
  ...rest 
}: CustomPaginationProps) => {
  const handlePageSizeChange = (event: any) => {
    const newPageSize = event.target.value as number;
    onPageSizeChange?.(newPageSize);
  };

  return (
    <PaginationContainer>
      {showPageSizeSelector && onPageSizeChange && totalPages > 0 && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '0.875rem' }}>
            Itens por página:
          </Typography>
          <FormControl size="small" sx={{ minWidth: 80 }}>
            <PageSizeSelect
              value={pageSize}
              onChange={handlePageSizeChange}
              displayEmpty
            >
              {PAGE_SIZE_OPTIONS.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </PageSizeSelect>
          </FormControl>
        </Box>
      )}
      {totalPages > 1 && (
        <StyledPagination
          shape="rounded"
          count={totalPages}
          page={currentPage}
          onChange={(_, value) => onPageChange(value)}
          {...rest}
        />
      )}
    </PaginationContainer>
  );
}; 